import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BottomNavigation } from '../components/bottom-navigation';
import { Toaster } from 'sonner';

// Root layout component that wraps all pages
const RootLayout = () => {
  const location = useLocation();
  const isPlanPage = location.pathname === '/plans';

  // State to track if bottom nav should be hidden
  const [shouldHideNav, setShouldHideNav] = useState(false);

  // Listen for custom events from the Plan page
  useEffect(() => {
    const handleBottomSheetStateChange = (event: CustomEvent) => {
      setShouldHideNav(event.detail.isExpanded);
    };

    // Add event listener
    window.addEventListener(
      'bottomSheetStateChange' as any,
      handleBottomSheetStateChange as any
    );

    // Clean up
    return () => {
      window.removeEventListener(
        'bottomSheetStateChange' as any,
        handleBottomSheetStateChange as any
      );
    };
  }, []);

  // Determine if bottom nav should be shown
  const showBottomNav = !(isPlanPage && shouldHideNav);

  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-gray-900 overflow-hidden mx-auto w-full
    ipad-mini:max-w-full surface-pro:max-w-full ipad:max-w-3xl ipad-pro:max-w-5xl ipad-pro-large:max-w-6xl">
      {/* Add Toaster component for toast notifications */}
      <Toaster position="top-center" />
      <main className="flex-1 pb-16 overflow-y-auto">
        <Outlet />
      </main>
      {/* Emergency button visible on all pages */}
      {/* <EmergencyButton /> */}
      {/* Show bottom navigation unless explicitly hidden */}
      {showBottomNav && <BottomNavigation />}
    </div>
  );
};

export default RootLayout;
